export interface ILocalization {
	"Abort": string;
	"Actions": string;
	"Add": string;
	"AddFilter": string;
	"All": string;
	"Apply": string;
	"Cache": string;
	"Cancel": string;
	"Clear": string;
	"ClearAll": string;
	"Close": string;
	"Column": string;
	"Columns": string;
	"Date": string;
	"Delete": string;
	"Deleted": string;
	"DeletedAll": string;
	"Description": string;
	"Download": string;
	"Downloaded": string;
	"Edit": string;
	"End": string;
	"EndDate": string;
	"Error": string;
	"Filter": string;
	"FilterTitle": string;
	"General": string;
	"Id": string;
	"Import": string;
	"Invalid": string;
	"Items": string;
	"Launch": string;
	"Live": string;
	"Message": string;
	"Name": string;
	"New": string;
	"No": string;
	"Now": string;
	"NoItemFilter": string;
	"NoItems": string;
	"Notification": string;
	"Off": string;
	"Ok": string;
	"On": string;
	"Preview": string;
	"Publish": string;
	"Refresh": string;
	"Reset": string;
	"Restore": string;
	"AvailableUpdates": string;
	"Remove": string;
	"Roles": string;
	"Save": string;
	"Saved": string;
	"Search": string;
	"SRID": string;
	"Start": string;
	"Stats": string;
	"Submit": string;
	"Sync": string;
	"Table": string;
	"Time": string;
	"Title": string;
	"Today": string;
	"Upload": string;
	"User": string;
	"Valid": string;
	"Value": string;
	"Yes": string;
	"Created": string;
	"Hour": string;
	"Day": string;
	"Week": string;
	"From": string;
	"To": string;
	"Color": string;
	"CSV": string;
	"Type": string;
	"Progress": {
		"Uploading": string;
		"Columns": string;
		"ChooseFilter": string;
		"PleaseWait": string;
		"Loading": string;
		"Redirect": string;
		"Login": string;
		"SendingRequest": string;
		"Validating": string;
		"Select": string;
		"Saving": string;
		"Imagery": string;
		"TestQuery": string;
		"Refreshing": string;
	};
	"License": {
		"Enterprise": string;
		"InvalidAccount": string;
		"LicensedTo": string;
		"MApp": string;
		"MApps": string;
		"ServiceDown": string;
		"FeatureRequiresPro": string;
	};
	"Errors": {
		"AccessDenied": string;
		"Activation": string;
		"DatabaseNoConnection": string;
		"LoginIncorrect": string;
		"MissingTenant": string;
		"NotFound": string;
		"NotImplemented": string;
		"NoValidationServer": string;
		"Occured": string;
		"PasswordMismatch": string;
		"Invalid": string;
		"Transformation": string;
		"CrsFromExisting": string;
		"ImportVectorData": string;
		"Action": string;
		"UnknownLocationType": string;
		"UnknownActionType": string;
		"Validation": string;
		"Query": string;
		"UnknownAppType": string;
		"Send": string;
		"MissingHexagonAppLauncher": {
			"Title": string;
			"HintStart": string;
			"HexagonAppLauncher": string;
			"HintEnd": string;
		};
		"WrongPassword": string;
		"MissingPassword": string;
		"ProvidedPasswordInvalid": string;
		"ProvidedPasswordsDontMatch": string;
		"ProvidedEmailInvalid": string;
	};
	"Login": {
		"ChangePassword": string;
		"EnableTwoFactor": string;
		"DisableTwoFactor": string;
		"QrCode": string;
		"EnterToken": string;
		"ConfirmPassword": string;
		"CurrentPassword": string;
		"Email": string;
		"ForgotPassword": string;
		"Guest": string;
		"HidePassword": string;
		"InstructionMail": string;
		"Login": string;
		"LoginButton": string;
		"Logout": string;
		"NewPassword": string;
		"NewPasswordConfirm": string;
		"Password": string;
		"ResetPassword": string;
		"SendingDone": string;
		"SendingFailed": string;
		"Settings": string;
		"Username": string;
		"Welcome": string;
		"Authorization": string;
		"Activated": string;
		"Pattern": string;
		"Passwords": string;
		"Fullname": string;
		"Token": string;
	};
	"Confirm": {
		"Delete": {
			"Singular": string;
			"Plural": string;
			"CustomCrsWarningSingular": string;
			"CustomCrsWarningPlural": string;
			"Warning": string;
		};
		"UnsavedChanges": string;
		"LoggedOut": string;
		"General": string;
	};
	"Activation": {
		"Activate": string;
		"Charge": string;
		"DefinePassword": string;
		"ReActivate": string;
		"SendActivation": string;
		"ActivationSent": string;
	};
	"Studio": {
		"Stats": {
			"Dataset": string;
			"Vector": string;
			"Content": string;
			"GoToApps": string;
		};
		"Tools": string;
		"Security": string;
		"Content": string;
		"Cache": string;
		"ActiveDirectory": {
			"ActiveDirectory": string;
			"Imported": string;
			"AzurePermissionsMissing": string;
		};
		"Image": string;
		"ApiKey": {
			"ApiKeys": string;
			"Note": string;
			"NoteText": string;
			"Token": string;
		};
		"Desktop": {
			"Desktop": string;
		};
		"Query": {
			"Queries": string;
			"ChooseQueryDataset": string;
			"ChooseDisplayDataset": string;
			"SqlQuery": string;
			"TestQuery": string;
			"QueryValid": string;
		};
		"PrintLayout": {
			"PrintLayouts": string;
			"PrintLayout": string;
			"PrintLayoutLabel": string;
			"Editor": string;
		};
		"OverView": {
			"OverViews": string;
			"OverView": string;
			"Name": string;
		};
		"ActionSet": {
			"Locations": {
				"Grid": string;
				"Left": string;
				"Frame": string;
			};
			"Location": string;
			"TopAction": string;
			"Hidden": string;
			"DataGrid": string;
			"Context": string;
			"ActionSets": string;
			"ActionSet": string;
			"ActionSetTitle": string;
			"StartOnLoad": string;
			"Tooltip": string;
			"Icon": string;
			"ChooseImage": string;
			"ActiveLayer": string;
			"ChooseActiveLayer": string;
			"ActiveLayerRequired": string;
			"MinSelection": string;
			"MaxSelection": string;
			"Target": string;
			"Width": string;
			"Height": string;
			"Blocking": string;
			"ViewSize": string;
			"ViewSizes": {
				"Default": string;
				"Half": string;
				"Extended": string;
				"Full": string;
			};
			"Url": string;
			"Workflow": string;
			"ChooseWorkflow": string;
			"Node": string;
			"BrowserUrl": string;
			"BrowserTarget": string;
			"OpenFile": string;
			"Top": string;
			"ActionGroup": string;
			"ValidationError": string;
		};
		"VectorData": {
			"VectorData": string;
			"Caching": string;
			"Import": string;
			"Geometry": string;
			"Snapable": string;
			"BufferSizeFactor": string;
			"Interpretation": string;
			"Vector": string;
			"GeometryType": string;
			"Dimension": string;
			"Refresh": {
				"Progress": string;
				"Success": {
					"Title": string;
					"Text": string;
				};
				"Redirect": {
					"HintStart": string;
					"HintLink": string;
					"HintEnd": string;
				};
				"Fail": string;
				"Label": string;
			};
		};
		"Imagery": {
			"Imagery": string;
			"Path": string;
			"Wms": string;
			"SelectType": string;
			"Wmts": string;
			"Ecwp": string;
			"Wfs": string;
			"Here": string;
		};
		"Geoservice": {
			"Geoservices": string;
			"MinScale": string;
			"MaxScale": string;
			"Format": string;
			"AppCode": string;
			"AppId": string;
			"ApiKey": string;
			"MapType": string;
			"MapTileType": string;
			"LanguageCode": string;
			"DualLanguageCode": string;
			"TileMatrix": string;
			"ServiceType": string;
			"Error": {
				"CannotConnect": string;
				"CheckLogs": string;
			};
			"Modal": {
				"Title": string;
				"CopyURLToClipBoard": string;
				"ShowEndpointURLS": string;
				"Notification": string;
				"NotPublished": string;
			};
		};
		"Copyright": {
			"Copyrights": string;
			"Text": string;
			"Assigned": string;
		};
		"AttributeData": {
			"AttributeData": string;
			"Attribute": string;
			"Attributes": string;
			"Type": string;
			"Import": string;
			"KeyField": string;
		};
		"Order": {
			"Orders": string;
			"State": string;
			"Progress": string;
			"Message": string;
		};
		"Recipe": {
			"Recipes": string;
		};
		"StyleSet": {
			"StyleSets": string;
			"Style": string;
			"Styles": string;
			"VectorLayer": string;
			"GeometryType": string;
			"Styled": string;
			"LaunchNewEditor": string;
		};
		"Role": {
			"Roles": string;
			"Role": string;
			"RolesLabel": string;
		};
		"App": {
			"App": string;
			"Apps": string;
		};
		"Legend": {
			"Name": string;
			"Legend": string;
			"LegendAction": string;
			"NameLayer": string;
			"NameTheme": string;
			"Legends": string;
			"AddTheme": string;
			"LegendLabel": string;
			"CannotDropOutsideTree": string;
			"DragDropDataset": string;
			"DropInvalidNode": string;
			"LayersNoSubLayers": string;
			"ThemesAboveLayers": string;
			"LayersAboveBasemaps": string;
			"LayersBelowThemes": string;
		};
		"MyGeoservice": {
			"Service": string;
			"MyGeoservices": string;
			"MyGeoservice": string;
			"MyGeoservicesButton": string;
			"FusionGeoService": string;
			"Depth": string;
			"StyleSet": string;
			"ApiKey": string;
			"WmsSettings": string;
			"SingleLayer": string;
			"WmtsSettings": string;
			"OnDemand": string;
			"Scale": string;
			"WfsSettings": string;
			"MaxNumFeatures": string;
		};
		"Dataset": {
			"Dataset": string;
			"Datasets": string;
			"DatasetsLabel": string;
			"Vectorsets": string;
			"Vectorset": string;
			"Layer": string;
			"Layers": string;
			"Feature": string;
		};
		"MapView": {
			"MapViews": string;
			"West": string;
			"East": string;
			"North": string;
			"South": string;
			"Name": string;
			"EPSG": string;
			"Bounds": string;
			"AutoBoundsSet": string;
			"AutoBoundsError": string;
			"AutoBoundsDisabled": string;
			"BoundsModeManual": string;
			"BoundsModeAuto": string;
			"NoPitchInManual": string;
			"StyleSets": string;
			"Legend": string;
			"PanToLayer": string;
			"EnableToPan": string;
			"UnlockBounds": string;
			"LockBounds": string;
			"PanToBounds": string;
			"ViewerOptions": string;
			"LayerTree": string;
			"ZoomTool": string;
			"PanTool": string;
			"MeasureTool": string;
			"Preview": string;
			"NoLegend": string;
			"NoLayers": string;
			"NoEpsg": string;
			"LoadError": string;
			"LoadDataError": string;
			"EnablePreview": string;
			"Render3D": string;
			"Effects": string;
			"MouseCoordinates": string;
			"CameraSettings": string;
		};
		"Job": {
			"Jobs": string;
			"Repeat": string;
			"Every": string;
			"Interval": string;
			"SwitchingSource": string;
			"Switch": string;
			"SwitchMessage": string;
			"Next": string;
		};
		"Epsg": {
			"Bounds": string;
			"TransformBounds": string;
			"NewEpsg": string;
			"Epsg": string;
			"TransformButton": string;
			"Crs": string;
			"CustomCrs": string;
			"FromExisting": string;
			"Wkt": string;
			"AreaOfUse": string;
			"AbridgedTransfromation": string;
			"TranslateX": string;
			"TranslateY": string;
			"TranslateZ": string;
			"RotateX": string;
			"RotateY": string;
			"RotateZ": string;
			"ScaleDifference": string;
		};
		"Browser": string;
		"Connection": {
			"Connection": string;
			"Database": string;
			"Datasource": string;
			"Host": string;
			"InitialCatalog": string;
			"Oracle": string;
			"Port": string;
			"PostgreSQL": string;
			"Hana": string;
			"Server": string;
			"Provider": string;
			"Section": string;
			"Source": string;
			"SqlServer": string;
		};
		"FeatureAnalyzer": string;
		"AnalyzerViews": string;
		"OpenEditor": string;
		"WorkflowEditor": string;
		"Workflows": string;
		"User": {
			"UsersTitle": string;
			"User": string;
			"Users": string;
			"Activation": {
				"Resend": string;
			};
			"BrandingUpdate": string;
			"BrandingError": string;
			"SettingsUpdate": string;
			"StudioAccount": string;
			"TwoFactor": string;
			"IsTwoFactorActivated": string;
			"IsTwoFactorRequired": string;
			"LanguageCode": string;
			"Theming": string;
			"AutomaticTheming": string;
			"DarkMode": string;
			"ConfirmResetDefaults": string;
			"EnterNewEmail": string;
			"EnterNewLanguage": string;
			"EnterCurrentPassword": string;
		};
		"Publish": {
			"Vector": string;
			"Wmts": string;
			"ClearCache": string;
			"CacheCleared": string;
		};
		"Area": {
			"Area": string;
			"ImportArea": string;
			"Import": string;
			"AreaNamePattern": string;
			"ChooseDataset": string;
		};
		"DataSource": {
			"DataSource": string;
			"DataSources": string;
			"ConnectionString": string;
			"NewConnection": string;
		};
		"FusionData": {
			"FusionData": string;
			"ServiceType": {
				"Elevation": string;
				"Ogc3dTile": string;
				"Panoramics": string;
			};
			"Endpoint": string;
			"QualityFactor": string;
			"TerrainOffset": string;
			"FusionImport": string;
			"FusionStudio": string;
			"PartOfTerrain": string;
		};
		"DeviceLogs": string;
		"Shell": string;
		"ShellLabel": string;
		"Mobile": string;
		"IsAreaRequired": string;
		"Branding": {
			"BrandingLabel": string;
			"BrandingColors": string;
			"ColorPalette": string;
			"PrimaryColor": string;
			"SecondaryColor": string;
			"PleaseEnterHex": string;
			"RestoreDefaults": string;
			"OverwriteDefaults": string;
			"Preview": string;
			"RestoreDialogMessage": string;
			"ColorPresets": string;
		};
	};
	"Management": {
		"Charges": string;
		"Logs": string;
		"Tenants": string;
		"TenantsField": string;
		"Session": string;
		"Usage": {
			"Usage": string;
			"PurchasedHours": string;
			"HoursUsed": string;
			"RemainingHours": string;
			"HoursCharacter": string;
			"Hours": string;
		};
		"Languages": {
			"Languages": string;
			"AvailableLanguages": string;
			"Code": string;
			"CompletedTranslationPercentage": string;
			"Language": string;
		};
		"Prediction": string;
		"Overview": string;
		"Environment": string;
		"ProductType": string;
		"StudioAccount": string;
		"DomainOptional": string;
		"ActiveDirectoryOptional": string;
		"None": string;
		"AzureActiveDirectory": string;
		"WsFederation": string;
		"ActiveDirectory": string;
		"OpenIdConnect": string;
		"ClientId": string;
		"TenantId": string;
		"ClientSecret": string;
		"adUsername": string;
		"adPassword": string;
		"adPath": string;
		"Domain": string;
		"Type": string;
		"UseAD": string;
		"OpenStudio": string;
		"TwoFactorAuthentication": string;
		"OpenIdConnectClientId": string;
		"OpenIdConnectClientSecret": string;
		"OpenIdConnectGroupsClaim": string;
		"OpenIdConnectDiscoveryUrl": string;
		"OpenIdConnectAuthUrl": string;
		"OpenIdConnectTokenUrl": string;
		"OpenIdConnectUserInfoUrl": string;
		"PreferThirdPartyLogin": string;
	};
	"Validation": {
		"Ok": string;
		"Saving": string;
		"DatasetNameExists": string;
		"isValidName": string;
		"isValidTitle": string;
		"isValidUsername": string;
		"lessThanDigit": string;
		"greaterThanDigit": string;
		"email_v2": string;
		"atLeastOne": string;
		"required": string;
		"min": string;
		"max": string;
		"minLength": string;
		"maxLength": string;
		"pattern": string;
		"step": string;
		"email": string;
		"date": string;
		"dateISO": string;
		"number": string;
		"digit": string;
		"phoneUS": string;
		"equal": string;
		"notEqual": string;
		"unique": string;
		"greaterThanMaxNumber": string;
		"lessThanMinNumber": string;
		"legendMissing": string;
		"tilingInfoMissing": string;
		"layerBoundsOutside": string;
		"keyFieldMissing": string;
		"appConfigMissing": string;
		"childIsInvalid": string;
		"missingCRS": string;
		"dataSourceMissing": string;
		"shellMissing": string;
		"fileSize": string;
		"shellXamlMissing": string;
		"vectorSetIsEmpty": string;
		"TransformBoundsError": string;
	};
	"Apps": {
		"StyleEditor": {
			"Button": {
				"Add_symbolizer": string;
				"Add_rule": string;
				"Bind_DB": string;
				"Delete_rule": string;
				"Delete_symbolizer": string;
				"Delete_style": string;
				"Pan_To_Layer": string;
				"Hide_Layer": string;
				"Make_Layer_Permanent": string;
				"No_Bounds": string;
				"Point_placement": string;
				"Expert_point_placement": string;
				"Line_placement": string;
			};
			"Hints": {
				"NoStyleSelected": string;
				"RefreshNecessary": string;
				"InvalidExternalReference": string;
				"ContainsInvalidExternalReference": string;
			};
			"Wizards": {
				"ColorScheme": string;
				"Categories": string;
				"Distribution": string;
				"Classes": string;
				"Field": string;
				"Style": string;
				"Hints": {
					"MostRelevantHint": string;
					"LessThanThreeHint": string;
					"NoDBFieldsAvailable": string;
					"ClassifyOnlyForNumericValues": string;
					"MoreThan50Categories": string;
				};
				"Errors": {
					"DbFieldsCouldNotBeFetched": string;
					"ValuesofDbfieldsCouldnotBeFetched": string;
				};
			};
			"FileUploadComponent": {
				"NoFileSelected": string;
				"InvalidReferencePleaseCheck": string;
				"NoFilesAvailable": string;
			};
			"General": {
				"Text": string;
				"Simple": string;
				"Expert": string;
				"Simple_fill": string;
				"Graphic_fill_filled_mark": string;
				"Graphic_fill_stroked_mark": string;
				"Graphic_fill_stroked_and_filled_mark": string;
				"Graphic_fill_external_graphic": string;
				"Custom_fill": string;
				"Stroked_mark": string;
				"Filled_mark": string;
				"Filled_and_stroked_mark": string;
				"External_graphic": string;
				"Custom_halo": string;
				"Custom_graphic": string;
				"Simple_line": string;
				"Dashed_line": string;
				"Graphic_stroke_Stroked_mark": string;
				"Graphic_stroke_Filled_mark": string;
				"Graphic_stroke_FilledAndStroked_mark": string;
				"Graphic_stroke_External_graphic": string;
				"Left": string;
				"Bottom": string;
				"Right": string;
				"Top": string;
				"Center": string;
				"Square": string;
				"Circle": string;
				"Triangle": string;
				"Cross": string;
				"Star": string;
				"Unit": string;
				"Fill": string;
				"Fill_color": string;
				"Fill_opacity": string;
				"Stroke": string;
				"Stroke_width": string;
				"Stroke_color": string;
				"Stroke_opacity": string;
				"Name": string;
				"Label_text": string;
				"Horizontal": string;
				"Vertical": string;
				"Label_placement": string;
				"Graphic_size": string;
				"Graphic_fill": string;
				"Font_family": string;
				"Font_size": string;
				"Font_weight": string;
				"Font_style": string;
				"Opacity": string;
				"Rotation": string;
				"Displacement_X": string;
				"Displacement_Y": string;
				"Marktype": string;
				"Dasharray": string;
				"Dashoffset": string;
				"Initial_gap": string;
				"Gap": string;
				"Halo": string;
				"Radius": string;
				"AnchorPoint": string;
				"Is_aligned": string;
				"Is_repeated": string;
				"Perpendicular_offset": string;
				"Graphic_references": string;
				"None": string;
				"Custom": string;
				"Linecap": string;
				"Graphic": string;
				"File": string;
				"Linejoin": string;
				"Database": string;
				"Select_a_file": string;
				"Upload_a_file": string;
				"FileUploadError": string;
				"FileDeleteError": string;
				"Select_field": string;
				"Delete_custom_Rule": string;
				"Unlock_Rule": string;
				"ShowBigPreview": string;
				"HideBigPreview": string;
				"Unlock_SymbologyType": string;
				"Lock_SymbologyType": string;
				"SymbologyType": string;
				"Symbolizer": string;
				"SymbolLoadError": string;
				"From": string;
				"To": string;
				"Scale": string;
				"Search": string;
				"Filter": string;
				"Rule": string;
				"No_suggestion": string;
				"Loading_data": string;
				"Unstyled_Layer": string;
			};
		};
		"RiaClient": {
			"Titles": {
				"LayerTree": string;
				"MeasureTool": string;
				"Effects": string;
				"CameraControl": string;
				"SaveState": string;
				"Locate": string;
				"ZoomIn": string;
				"ZoomOut": string;
				"MouseLocation": string;
				"LeavePanorama": string;
			};
			"LayerTree": {
				"Title": string;
				"Actions": {
					"FitToData": string;
					"ToggleLayerVisibility": string;
					"ToggleBaseLayer": string;
					"CantFitToData": string;
				};
			};
			"MeasureTool": {
				"Title": string;
				"Labels": {
					"MeasureMode": string;
					"Off": string;
					"Distance": string;
					"Height": string;
					"Orthogonal": string;
					"Area": string;
					"TotalDistance": string;
					"TotalArea": string;
				};
			};
			"CameraControl": {
				"Title": string;
				"Labels": {
					"DefaultCamera": string;
					"FirstPersonCamera": string;
				};
			};
			"EffectsPanel": {
				"ambientOcclusion": string;
				"aoPower": string;
				"aoRadius": string;
				"antiAliasing": string;
				"atmosphere": string;
				"depthOfField": string;
				"dofFocalDepth": string;
				"dofFocusRange": string;
				"dofNoFocusRange": string;
				"dofScale": string;
				"eyeDomeLighting": string;
				"edlColor": string;
				"edlStrength": string;
				"edlWindow": string;
				"headLight": string;
				"hlAmbientColor": string;
				"hlDiffuseColor": string;
				"sunLight": string;
				"slAmbientColor": string;
				"slDiffuseColor": string;
				"slShadows": string;
				"slUseLiveTime": string;
				"slTime": string;
				"slDate": string;
				"slTimezone": string;
				"starfield": string;
			};
		};
		"AppEngine": {
			"AnalyzerView": string;
			"ApplicationType": string;
			"Bounds": string;
			"CodeSnippets": string;
			"Crs": string;
			"Legend": string;
			"Loading": string;
			"Markup": string;
			"NoScriptWarning": string;
			"Script": string;
			"SelectConfig": string;
			"Style": string;
			"StyleSet": string;
			"Vector": string;
			"Snippets": {
				"Communication": {
					"Title": string;
					"WaitAllPanelLoad": string;
					"SendMessageToAllPanels": string;
					"ListenToOtherPanels": string;
					"ListToSpecificPanel": string;
					"SendFunctionToOtherPanels": string;
				};
				"Utility": {
					"Title": string;
					"LoadThirdPartyLibs": string;
				};
				"PointCloud": {
					"Title": string;
					"PointCloudStyle": string;
				};
				"Layer": {
					"Title": string;
					"FindLayerByLabel": string;
					"FilterLayerByType": string;
					"ShowHideLayer": string;
					"CreateWmsLayer": string;
				};
				"MaeInterface": {
					"Title": string;
					"OpenWorkflow": string;
					"PerformQuery": string;
					"PerformTypedQuery": string;
					"PerformCSVQuery": string;
					"PerformGeoJSONQuery": string;
					"LoadExternalScript": string;
				};
				"Map": {
					"Title": string;
					"MapInformation": string;
					"PanToPoint": string;
					"PanToBounds": string;
					"Zoom": string;
					"Draw3DFeature": string;
					"AddCopyright": string;
				};
				"Recipes": {
					"Title": string;
					"ListenProcessStart": string;
					"ListenProcessStatusUpdate": string;
					"ListenProcessFinish": string;
					"GetProcessOutputs": string;
					"RegisterPreprocessor": string;
					"SendOutputToMapView": string;
				};
				"Transformation": {
					"Title": string;
					"RegisterCRS": string;
					"PointTransformation": string;
					"BoundsTransformation": string;
					"ShapeTransformation": string;
				};
				"Vector": {
					"Title": string;
					"EventHandlerSelectionChanged": string;
					"CreateCustomPainter": string;
				};
			};
		};
	};
}
export var Localization: ILocalization = {
	"Abort": "Abort",
	"Actions": "Actions",
	"Add": "Add",
	"AddFilter": "Add Filter",
	"All": "All",
	"Apply": "Apply",
	"Cache": "Cache",
	"Cancel": "Cancel",
	"Clear": "Clear",
	"ClearAll": "Clear All",
	"Close": "Close",
	"Column": "Column",
	"Columns": "Columns",
	"Date": "Date",
	"Delete": "Delete",
	"Deleted": "Deleted",
	"DeletedAll": "Deleted All",
	"Description": "Description",
	"Download": "Download",
	"Downloaded": "Downloaded",
	"Edit": "Edit",
	"End": "End",
	"EndDate": "End Date",
	"Error": "Error",
	"Filter": "Filter",
	"FilterTitle": "FILTER",
	"General": "GENERAL",
	"Id": "Id",
	"Import": "Import",
	"Invalid": "Invalid",
	"Items": "Items",
	"Launch": "Launch",
	"Live": "Live",
	"Message": "Message",
	"Name": "Name",
	"New": "New",
	"No": "No",
	"Now": "Now",
	"NoItemFilter": "NO ITEM MATCHES FILTER CONDITIONS",
	"NoItems": "NO ITEMS",
	"Notification": "Notification",
	"Off": "Off",
	"Ok": "Ok",
	"On": "On",
	"Preview": "Preview",
	"Publish": "Publish",
	"Refresh": "Refresh",
	"Reset": "Reset",
	"Restore": "Restore",
	"AvailableUpdates": "Updates available",
	"Remove": "Remove",
	"Roles": "Roles",
	"Save": "Save",
	"Saved": "Saved",
	"Search": "Search",
	"SRID": "EPSG",
	"Start": "Start",
	"Stats": "Stats",
	"Submit": "Submit",
	"Sync": "Sync",
	"Table": "Table",
	"Time": "Time",
	"Title": "Title",
	"Today": "Today",
	"Upload": "Upload",
	"User": "User",
	"Valid": "Valid",
	"Value": "Value",
	"Yes": "Yes",
	"Created": "Created",
	"Hour": "Hour",
	"Day": "Day",
	"Week": "Week",
	"From": "From",
	"To": "To",
	"Color": "Color",
	"CSV": "CSV",
	"Type": "Type",
	"Progress": {
		"Uploading": "Uploading...",
		"Columns": "Columns...",
		"ChooseFilter": "Choose Filter Operator...",
		"PleaseWait": "Please wait...",
		"Loading": "Loading...",
		"Redirect": "Redirect...",
		"Login": "Login...",
		"SendingRequest": "Sending request...",
		"Validating": "Validating...",
		"Select": "Select...",
		"Saving": "Saving...",
		"Imagery": "Processing imagery...",
		"TestQuery": "Testing Query...",
		"Refreshing": "Refreshing..."
	},
	"License": {
		"Enterprise": "ENTERPRISE",
		"InvalidAccount": "This system is using an invalid license! Please contact your System administrator or Hexagon Geospatial.<br/>By using the system you are in violation of the End-User-License-Agreement (EULA) and your license is subject to termination.",
		"LicensedTo": "Licensed to",
		"MApp": "M.App",
		"MApps": "M.APPS",
		"ServiceDown": "Usage statistics cannot be synchronized, because the service is not running or lost connectivity.",
		"FeatureRequiresPro": "This feature requires a Professional license"
	},
	"Errors": {
		"AccessDenied": "Access denied!",
		"Activation": "Activation Error!",
		"DatabaseNoConnection": "Can not connect to database.",
		"LoginIncorrect": "The user name or password is incorrect!",
		"MissingTenant": "Missing Tenant!",
		"NotFound": "Not Found!",
		"NotImplemented": "Not implemented!",
		"NoValidationServer": "Could not validate. Internal server error.",
		"Occured": "An error occurred!",
		"PasswordMismatch": "Password pattern is not matched.",
		"Invalid": "Invalid!",
		"Transformation": "Transformation failed",
		"CrsFromExisting": "CRS From Existing failed",
		"ImportVectorData": "An error occured while importing vector data! Please define the caching information manually.",
		"Action": "-Invalid Name-",
		"UnknownLocationType": "Unknown Location Type",
		"UnknownActionType": "Unknown Action Type",
		"Validation": "Validation Error!",
		"Query": "Could not validate query definition.",
		"UnknownAppType": "AppType unknown or not implemented.",
		"Send": "Sending failed.",
		"MissingHexagonAppLauncher": {
			"Title": "App not opening?",
			"HintStart": "Make sure you have",
			"HexagonAppLauncher": "Hexagon App Launcher",
			"HintEnd": "installed."
		},
		"WrongPassword": "Wrong password. Please try again.",
		"MissingPassword": "Please enter current password.",
		"ProvidedPasswordInvalid": "Provided password is not valid. Please try again.",
		"ProvidedPasswordsDontMatch": "Provided passwords do not match. Please try again.",
		"ProvidedEmailInvalid": "Provided email is not valid. Please try again."
	},
	"Login": {
		"ChangePassword": "Change password",
		"EnableTwoFactor": "Enable two factor authentication",
		"DisableTwoFactor": "Disable Two Factor Authentication",
		"QrCode": "Scan QR Code with an authenticator app (e.g.: Google Authenticator, Microsoft Authenticator, ...)",
		"EnterToken": "Enter token*",
		"ConfirmPassword": "Password confirm",
		"CurrentPassword": "Current password",
		"Email": "Email",
		"ForgotPassword": "Forgot password?",
		"Guest": "Guest",
		"HidePassword": "Hide Password",
		"InstructionMail": "We will send you an email with instructions to reset your password",
		"Login": "Login",
		"LoginButton": "Login",
		"Logout": "LOGOUT",
		"NewPassword": "New password",
		"NewPasswordConfirm": "New password confirm",
		"Password": "Password",
		"ResetPassword": "Reset password",
		"SendingDone": "An email has been sent to reset the password",
		"SendingFailed": "Could not send mail to user!",
		"Settings": "SETTINGS",
		"Username": "Username",
		"Welcome": "Welcome",
		"Authorization": "Authorization",
		"Activated": "Activated",
		"Pattern": "Pattern",
		"Passwords": "PASSWORDS",
		"Fullname": "Fullname",
		"Token": "Token"
	},
	"Confirm": {
		"Delete": {
			"Singular": "Are you sure you want to delete this item?",
			"Plural": "Are you sure you want to delete these items?",
			"CustomCrsWarningSingular": "Deleting this CRS will invalidate all related objects. Are you sure?",
			"CustomCrsWarningPlural": "Deleting these CRS will invalidate all related objects. Are you sure?",
			"Warning": "Warning"
		},
		"UnsavedChanges": "All unsaved changes will be discared.<br/>Are you sure you want to cancel?",
		"LoggedOut": "You will be logged out automatically.<br/>Are you sure you want to proceed?",
		"General": "Are you sure?"
	},
	"Activation": {
		"Activate": "Activate",
		"Charge": "Charge",
		"DefinePassword": "Choose a password to activate new user.",
		"ReActivate": "Re-activate user",
		"SendActivation": "Send account activation mail to {0}?",
		"ActivationSent": "Activation mail has been sent to {0}"
	},
	"Studio": {
		"Stats": {
			"Dataset": "Dataset Type Stats",
			"Vector": "Vector Type Stats",
			"Content": "Content Type Stats",
			"GoToApps": "Go to Apps Page"
		},
		"Tools": "TOOLS",
		"Security": "SECURITY",
		"Content": "CONTENT",
		"Cache": "CACHE",
		"ActiveDirectory": {
			"ActiveDirectory": "ACTIVE DIRECTORY",
			"Imported": "Imported",
			"AzurePermissionsMissing": "Missing Azure Permissions"
		},
		"Image": "IMAGE",
		"ApiKey": {
			"ApiKeys": "API KEYS",
			"Note": "NOTE",
			"NoteText": "Treat your tokens like passwords and keep them secret.",
			"Token": "Token"
		},
		"Desktop": {
			"Desktop": "DESKTOP"
		},
		"Query": {
			"Queries": "QUERIES",
			"ChooseQueryDataset": "Choose Query Dataset",
			"ChooseDisplayDataset": "Choose Display Dataset",
			"SqlQuery": "SQL Query",
			"TestQuery": "Test Query",
			"QueryValid": "Query definition is valid."
		},
		"PrintLayout": {
			"PrintLayouts": "PRINT LAYOUTS",
			"PrintLayout": "PRINT LAYOUT",
			"PrintLayoutLabel": "Print Layout",
			"Editor": "PRINT LAYOUT EDITOR"
		},
		"OverView": {
			"OverViews": "OVERVIEWS",
			"OverView": "OVERVIEW",
			"Name": "Name of Overview"
		},
		"ActionSet": {
			"Locations": {
				"Grid": "Data Grid",
				"Left": "Sidebar",
				"Frame": "Frame"
			},
			"Location": "Location",
			"TopAction": "TopAction",
			"Hidden": "Hidden",
			"DataGrid": "Data Grid",
			"Context": "Context",
			"ActionSets": "ACTION SETS",
			"ActionSet": "Action Set",
			"ActionSetTitle": "ACTION SET",
			"StartOnLoad": "Start On Load",
			"Tooltip": "Tooltip",
			"Icon": "Icon",
			"ChooseImage": "Choose Image",
			"ActiveLayer": "Active Layer",
			"ChooseActiveLayer": "Choose Active Layer",
			"ActiveLayerRequired": "Active Layer Required",
			"MinSelection": "Min. Selection",
			"MaxSelection": "Max. Selection",
			"Target": "Target",
			"Width": "Width",
			"Height": "Height",
			"Blocking": "Blocking",
			"ViewSize": "View Size",
			"ViewSizes": {
				"Default": "Default",
				"Half": "Half",
				"Extended": "Extended",
				"Full": "Full"
			},
			"Url": "Url",
			"Workflow": "Workflow",
			"ChooseWorkflow": "Choose Workflow",
			"Node": "Node",
			"BrowserUrl": "Browser (Url)",
			"BrowserTarget": "Browser (Target)",
			"OpenFile": "Open File",
			"Top": "Top",
			"ActionGroup": "Action Group",
			"ValidationError": "Validation Error"
		},
		"VectorData": {
			"VectorData": "VECTOR DATA",
			"Caching": "Caching",
			"Import": "Import Vector",
			"Geometry": "Geometry",
			"Snapable": "Snapable",
			"BufferSizeFactor": "Buffersize Factor",
			"Interpretation": "Interpretation",
			"Vector": "Vector",
			"GeometryType": "Geometry Type",
			"Dimension": "Dimension",
			"Refresh": {
				"Progress": "Please wait while the meta information is getting refreshed.",
				"Success": {
					"Title": "The refreshing process is successfully completed.",
					"Text": "All corresponding cached data are getting subsequently updated now."
				},
				"Redirect": {
					"HintStart": "Click",
					"HintLink": "here",
					"HintEnd": "to view the progress state."
				},
				"Fail": "An error occured while trying to refresh the meta information.",
				"Label": "Refresh geometry information"
			}
		},
		"Imagery": {
			"Imagery": "IMAGERY",
			"Path": "Path",
			"Wms": "WMS",
			"SelectType": "Select at least one service type.",
			"Wmts": "WMTS",
			"Ecwp": "ECWP",
			"Wfs": "WFS",
			"Here": "HERE Maps"
		},
		"Geoservice": {
			"Geoservices": "GEOSERVICES",
			"MinScale": "Min. Scale",
			"MaxScale": "Max. Scale",
			"Format": "Format",
			"AppCode": "App Code",
			"AppId": "App ID",
			"ApiKey": "API Key",
			"MapType": "Type",
			"MapTileType": "Tile Type",
			"LanguageCode": "Language",
			"DualLanguageCode": "Second Language",
			"TileMatrix": "TileMatrix",
			"ServiceType": "Service Type",
			"Error": {
				"CannotConnect": "Cannot connect to service",
				"CheckLogs": "Please check the logs for more information"
			},
			"Modal": {
				"Title": "GeoService endpoint URLs",
				"CopyURLToClipBoard": "Copy endpoint URL to clipboard",
				"ShowEndpointURLS": "Show endpoint URLs",
				"Notification": "Endpoint URL has been copied to your clipboard!",
				"NotPublished": "Not yet published"
			}
		},
		"Copyright": {
			"Copyrights": "COPYRIGHTS",
			"Text": "Copyright Text",
			"Assigned": "Assigned copyright"
		},
		"AttributeData": {
			"AttributeData": "ATTRIBUTE DATA",
			"Attribute": "Attribute",
			"Attributes": "Attributes",
			"Type": "Type",
			"Import": "Import Attribute data",
			"KeyField": "Key Field"
		},
		"Order": {
			"Orders": "ORDERS",
			"State": "State",
			"Progress": "Progress",
			"Message": "Message"
		},
		"Recipe": {
			"Recipes": "RECIPES"
		},
		"StyleSet": {
			"StyleSets": "STYLESETS",
			"Style": "Style",
			"Styles": "Styles",
			"VectorLayer": "Vector Layer",
			"GeometryType": "Geometry Type",
			"Styled": "Styled",
			"LaunchNewEditor": "Launch in new Style Editor"
		},
		"Role": {
			"Roles": "ROLES",
			"Role": "Role",
			"RolesLabel": "Roles"
		},
		"App": {
			"App": "App",
			"Apps": "Apps"
		},
		"Legend": {
			"Name": "Legend Name",
			"Legend": "LEGEND",
			"LegendAction": "Legend",
			"NameLayer": "Name of Layer",
			"NameTheme": "Name of Theme",
			"Legends": "LEGENDS",
			"AddTheme": "Add Theme",
			"LegendLabel": "Legend",
			"CannotDropOutsideTree": "Cannot drop outside of tree.",
			"DragDropDataset": "Drag & Drop Datasets here.",
			"DropInvalidNode": "Cannot drop invalid node.",
			"LayersNoSubLayers": "Layers cannot have sublayers.",
			"ThemesAboveLayers": "Themes must be placed above layers on the same level.",
			"LayersAboveBasemaps": "Layers must be placed above Basemaps.",
			"LayersBelowThemes": "Layers must be placed below themes on the same level"
		},
		"MyGeoservice": {
			"Service": "Service",
			"MyGeoservices": "MY GEOSERVICES",
			"MyGeoservice": "My GeoService",
			"MyGeoservicesButton": "My GeoServices",
			"FusionGeoService": "Fusion GeoServices",
			"Depth": "Depth",
			"StyleSet": "Choose Style Set",
			"ApiKey": "Secure with API Key",
			"WmsSettings": "WMS SETTINGS",
			"SingleLayer": "Single Layer",
			"WmtsSettings": "WMTS SETTINGS",
			"OnDemand": "OnDemand",
			"Scale": "Scale",
			"WfsSettings": "WFS SETTINGS",
			"MaxNumFeatures": "Maximum feature count"
		},
		"Dataset": {
			"Dataset": "Dataset",
			"Datasets": "DATASETS",
			"DatasetsLabel": "Datasets",
			"Vectorsets": "VECTOR SETS",
			"Vectorset": "Vector Set",
			"Layer": "Layer",
			"Layers": "Layers",
			"Feature": "Feature"
		},
		"MapView": {
			"MapViews": "MAP VIEWS",
			"West": "West",
			"East": "East",
			"North": "North",
			"South": "South",
			"Name": "Name",
			"EPSG": "EPSG",
			"Bounds": "Bounds",
			"AutoBoundsSet": "Bounds set from map",
			"AutoBoundsError": "Could not fetch bounds from map",
			"AutoBoundsDisabled": "Enable Preview to fetch bounds from map",
			"BoundsModeManual": "Manual",
			"BoundsModeAuto": "Auto",
			"NoPitchInManual": "Cannot pitch camera in Manual Mode",
			"StyleSets": "StyleSet",
			"Legend": "Legend",
			"PanToLayer": "Pan to Layer",
			"EnableToPan": "Enable Preview to pan to use panning",
			"UnlockBounds": "Unlock bounds from map",
			"LockBounds": "Lock bounds to map",
			"PanToBounds": "Pan to bounds",
			"ViewerOptions": "Viewer Options",
			"LayerTree": "Layer Tree",
			"ZoomTool": "Zoom Tool",
			"PanTool": "Pan Tool",
			"MeasureTool": "Measure Tool",
			"Preview": "Preview",
			"NoLegend": "No legend selected",
			"NoLayers": "No layers in selected legend",
			"NoEpsg": "No valid EPSG selected",
			"LoadError": "Could not load MapView with id ",
			"LoadDataError": "Could not load data",
			"EnablePreview": "Enable Preview",
			"Render3D": "Render 3D Map",
			"Effects": "Effects",
			"MouseCoordinates": "Mouse coordinates",
			"CameraSettings": "Camera settings"
		},
		"Job": {
			"Jobs": "JOBS",
			"Repeat": "Repeat",
			"Every": "Every",
			"Interval": "Interval",
			"SwitchingSource": "Switching source",
			"Switch": "Switch",
			"SwitchMessage": "There are some selected items in the current table.<br/>If you switch to another source table you will lose your selection.",
			"Next": "Next"
		},
		"Epsg": {
			"Bounds": "Bounds",
			"TransformBounds": "Transform Bounds",
			"NewEpsg": "New EPSG",
			"Epsg": "EPSG",
			"TransformButton": "Transform",
			"Crs": "CRS",
			"CustomCrs": "CUSTOM CRS",
			"FromExisting": "From Existing",
			"Wkt": "Well Known Text (WKT 2)",
			"AreaOfUse": "AREA OF USE",
			"AbridgedTransfromation": "ABRIDGED TRANSFORMATION",
			"TranslateX": "Translate X",
			"TranslateY": "Translate Y",
			"TranslateZ": "Translate Z",
			"RotateX": "Rotate X",
			"RotateY": "Rotate Y",
			"RotateZ": "Rotate Z",
			"ScaleDifference": "Scale Difference"
		},
		"Browser": "BROWSER",
		"Connection": {
			"Connection": "Connection",
			"Database": "Database",
			"Datasource": "Data Source",
			"Host": "Host",
			"InitialCatalog": "Initial Catalog",
			"Oracle": "Oracle",
			"Port": "Port",
			"PostgreSQL": "PostGIS",
			"Hana": "Hana",
			"Server": "Server",
			"Provider": "Provider",
			"Section": "CONNECTIONS",
			"Source": "Source",
			"SqlServer": "Microsoft SQL Server"
		},
		"FeatureAnalyzer": "Feature Analyzer",
		"AnalyzerViews": "ANALYZER VIEWS",
		"OpenEditor": "Open in editor",
		"WorkflowEditor": "Workflow Editor",
		"Workflows": "WORKFLOWS",
		"User": {
			"UsersTitle": "USERS",
			"User": "User",
			"Users": "Users",
			"Activation": {
				"Resend": "Resend activation"
			},
			"BrandingUpdate": "Branding colors updated.",
			"BrandingError": "Branding colors could'nt be saved.",
			"SettingsUpdate": "User settings updated.",
			"StudioAccount": "Studio Account",
			"TwoFactor": "Two Factor",
			"IsTwoFactorActivated": "Two Factor Activated?",
			"IsTwoFactorRequired": "Require Two Factor?",
			"LanguageCode": "Language",
			"Theming": "Theming",
			"AutomaticTheming": "Automatic theming",
			"DarkMode": "Darkmode",
			"ConfirmResetDefaults": "Restore defaults colors",
			"EnterNewEmail": "New email*",
			"EnterNewLanguage": "New language*",
			"EnterCurrentPassword": "Current password*"
		},
		"Publish": {
			"Vector": "Publish Vector",
			"Wmts": "Publish Wmts",
			"ClearCache": "Clear Wmts Cache",
			"CacheCleared": "Cache cleared"
		},
		"Area": {
			"Area": "AREA",
			"ImportArea": "Import Areas",
			"Import": "Import",
			"AreaNamePattern": "Name Pattern",
			"ChooseDataset": "Choose Dataset"
		},
		"DataSource": {
			"DataSource": "DATASOURCE",
			"DataSources": "DATASOURCES",
			"ConnectionString": "Connection String",
			"NewConnection": "New Connection"
		},
		"FusionData": {
			"FusionData": "3D DATA",
			"ServiceType": {
				"Elevation": "ELEVATION",
				"Ogc3dTile": "OGC 3D TILES",
				"Panoramics": "PANORAMICS"
			},
			"Endpoint": "Endpoint",
			"QualityFactor": "Quality Factor",
			"TerrainOffset": "Terrain Offset",
			"FusionImport": "Fusion Import",
			"FusionStudio": "FUSION STUDIO",
			"PartOfTerrain": "Part of terrain"
		},
		"DeviceLogs": "DEVICE LOGS",
		"Shell": "SHELL",
		"ShellLabel": "Shell",
		"Mobile": "MOBILE",
		"IsAreaRequired": "Area required?",
		"Branding": {
			"BrandingLabel": "BRANDING",
			"BrandingColors": "BRANDING COLORS",
			"ColorPalette": "COLOR PALETTE",
			"PrimaryColor": "Primary*",
			"SecondaryColor": "Secondary",
			"PleaseEnterHex": "Please enter a hex color code.",
			"RestoreDefaults": "Restore defaults",
			"OverwriteDefaults": "Overwrite default colors",
			"Preview": "Preview",
			"RestoreDialogMessage": "Are you sure you want to restore the default color settings?",
			"ColorPresets": "Color presets"
		}
	},
	"Management": {
		"Charges": "CHARGES",
		"Logs": "LOGS",
		"Tenants": "TENANTS",
		"TenantsField": "Tenants",
		"Session": "Session",
		"Usage": {
			"Usage": "USAGE",
			"PurchasedHours": "Purchased hours",
			"HoursUsed": "Hours used",
			"RemainingHours": "Remaining hours",
			"HoursCharacter": "h",
			"Hours": "Hours"
		},
		"Languages": {
			"Languages": "LANGUAGES",
			"AvailableLanguages": "Available Languages",
			"Code": "Code",
			"CompletedTranslationPercentage": "Translation status (%)",
			"Language": "Language"
		},
		"Prediction": "PREDICTION",
		"Overview": "OVERVIEW",
		"Environment": "Environment",
		"ProductType": "Type",
		"StudioAccount": "STUDIO ACCOUNT",
		"DomainOptional": "DOMAIN (OPTIONAL)",
		"ActiveDirectoryOptional": "ACTIVE DIRECTORY INTEGRATION (OPTIONAL)",
		"None": "None",
		"AzureActiveDirectory": "Azure",
		"WsFederation": "WS-Federation",
		"ActiveDirectory": "Active Directory",
		"OpenIdConnect": "OpenID Connect",
		"ClientId": "Client ID",
		"TenantId": "Tenant ID",
		"ClientSecret": "Client Secret",
		"adUsername": "AD Username",
		"adPassword": "AD Password",
		"adPath": "AD Path",
		"Domain": "Domain",
		"Type": "Type",
		"UseAD": "Use Active Directory",
		"OpenStudio": "Open Studio",
		"TwoFactorAuthentication": "TWO FACTOR AUTHENTICATION",
		"OpenIdConnectClientId": "Client Id",
		"OpenIdConnectClientSecret": "Client Secret (optional)",
		"OpenIdConnectGroupsClaim": "Groups Claim (optional)",
		"OpenIdConnectDiscoveryUrl": "Discovery Url",
		"OpenIdConnectAuthUrl": "Auth Url",
		"OpenIdConnectTokenUrl": "Token Url",
		"OpenIdConnectUserInfoUrl": "User Info Url",
		"PreferThirdPartyLogin": "Prefer third party login?"
	},
	"Validation": {
		"Ok": "Ok.",
		"Saving": "Saving...",
		"DatasetNameExists": "Dataset Name already exists.",
		"isValidName": "Name too long or invalid. (Allowed: a-zA-Z_0-9)",
		"isValidTitle": "Name too long or invalid characters.",
		"isValidUsername": "Username too long or invalid characters.",
		"lessThanDigit": "Value has to be less than {0}.",
		"greaterThanDigit": "Value has to be greater than {0}.",
		"email_v2": "Email is not valid.",
		"atLeastOne": "Select at least one item.",
		"required": "This field is required.",
		"min": "Please enter a value greater than or equal to {0}.",
		"max": "Please enter a value less than or equal to {0}.",
		"minLength": "Please enter at least {0} characters.",
		"maxLength": "Please enter no more than {0} characters.",
		"pattern": "Please check this value.",
		"step": "The value must increment by {0}.",
		"email": "Please enter a proper email address.",
		"date": "Please enter a proper date.",
		"dateISO": "Please enter a proper date.",
		"number": "Please enter a number.",
		"digit": "Please enter a digit.",
		"phoneUS": "Please specify a valid phone number.",
		"equal": "Values must equal.",
		"notEqual": "Please choose another value.",
		"unique": "Please make sure the value is unique.",
		"greaterThanMaxNumber": "Value exceeds the valid value range.",
		"lessThanMinNumber": "Value falls below the valid value range.",
		"legendMissing": "Missing Legend.",
		"tilingInfoMissing": "Missing tile info.",
		"layerBoundsOutside": "Layer bounds outside of CRS bounds.",
		"keyFieldMissing": "KeyField is missing.",
		"appConfigMissing": "Missing App Configuration.",
		"childIsInvalid": "One child element is invalid.",
		"missingCRS": "SRID is not valid",
		"dataSourceMissing": "Missing data source.",
		"shellMissing": "Missing shell.",
		"fileSize": "The file size exceeds the limit allowed ({0}) and cannot be saved.",
		"shellXamlMissing": "Missing Shell.xaml in top level.",
		"vectorSetIsEmpty": "VectorSet is empty.",
		"TransformBoundsError": "Could not transform bounds from SRID {0} to SRID {1}."
	},
	"Apps": {
		"StyleEditor": {
			"Button": {
				"Add_symbolizer": "Add symbolizer",
				"Add_rule": "Add rule",
				"Bind_DB": "Bind to database column",
				"Delete_rule": "Delete rule",
				"Delete_symbolizer": "Delete symbolizer",
				"Delete_style": "Delete style",
				"Pan_To_Layer": "Pan to layer",
				"Hide_Layer": "Hide layer",
				"Make_Layer_Permanent": "Make layer permanent",
				"No_Bounds": "No bounds information available",
				"Point_placement": "Point placement",
				"Expert_point_placement": "Expert point placement",
				"Line_placement": "Line placement"
			},
			"Hints": {
				"NoStyleSelected": "No style selected",
				"RefreshNecessary": "Saving of styleset necessary to get database value for this field",
				"InvalidExternalReference": "Invalid external reference",
				"ContainsInvalidExternalReference": "Contains invalid external reference"
			},
			"Wizards": {
				"ColorScheme": "Color scheme",
				"Categories": "Categories",
				"Distribution": "Distribution",
				"Classes": "Classes",
				"Field": "Field",
				"Style": "Style",
				"Hints": {
					"MostRelevantHint": "Most relevant values selected automatically due to selected db field containing more than 10 distinct values.",
					"LessThanThreeHint": "Selected database field contains less than 3 distinct values. Categorization not supported.",
					"NoDBFieldsAvailable": "No db fields available for selected style",
					"ClassifyOnlyForNumericValues": "Caution: Generating classified rules is only possible for numeric values",
					"MoreThan50Categories": "Caution: Color generation is only available for up to 54 categories. More colors have to be selected manually"
				},
				"Errors": {
					"DbFieldsCouldNotBeFetched": "Error: Database fields could not be fetched.",
					"ValuesofDbfieldsCouldnotBeFetched": "Error: Values of field could not be fetched."
				}
			},
			"FileUploadComponent": {
				"NoFileSelected": "-- No file selected --",
				"InvalidReferencePleaseCheck": "-- Invalid reference, please check --",
				"NoFilesAvailable": "-- No files available. Please upload --"
			},
			"General": {
				"Text": "Text",
				"Simple": "Simple",
				"Expert": "Expert",
				"Simple_fill": "Simple fill",
				"Graphic_fill_filled_mark": "Graphic fill | Filled mark",
				"Graphic_fill_stroked_mark": "Graphic fill | Stroked mark",
				"Graphic_fill_stroked_and_filled_mark": "Graphic fill | Filled & Stroked mark",
				"Graphic_fill_external_graphic": "Graphic fill | External graphic",
				"Custom_fill": "Custom Fill",
				"Stroked_mark": "Stroked mark",
				"Filled_mark": "Filled mark",
				"Filled_and_stroked_mark": "Filled & Stroked mark",
				"External_graphic": "External graphic",
				"Custom_halo": "Custom Halo",
				"Custom_graphic": "Custom graphic",
				"Simple_line": "Simple line",
				"Dashed_line": "Dashed line",
				"Graphic_stroke_Stroked_mark": "Graphic stroke | Stroked mark",
				"Graphic_stroke_Filled_mark": "Graphic stroke | Filled mark",
				"Graphic_stroke_FilledAndStroked_mark": "Graphic stroke | Filled & Stroked mark",
				"Graphic_stroke_External_graphic": "Graphic stroke | External graphic",
				"Left": "Left",
				"Bottom": "Bottom",
				"Right": "Right",
				"Top": "Top",
				"Center": "Center",
				"Square": "Square",
				"Circle": "Circle",
				"Triangle": "Triangle",
				"Cross": "Cross",
				"Star": "Star",
				"Unit": "Unit",
				"Fill": "Fill",
				"Fill_color": "Fill color",
				"Fill_opacity": "Fill opacity",
				"Stroke": "Stroke",
				"Stroke_width": "Stroke width",
				"Stroke_color": "Stroke color",
				"Stroke_opacity": "Stroke opacity",
				"Name": "Name",
				"Label_text": "Label text",
				"Horizontal": "Horizontal",
				"Vertical": "Vertical",
				"Label_placement": "Label placement",
				"Graphic_size": "Graphic size",
				"Graphic_fill": "Graphic fill",
				"Font_family": "Font family",
				"Font_size": "Font size",
				"Font_weight": "Font weight",
				"Font_style": "Font style",
				"Opacity": "Opacity",
				"Rotation": "Rotation",
				"Displacement_X": "Displacement X",
				"Displacement_Y": "Displacement Y",
				"Marktype": "Marktype",
				"Dasharray": "Dasharray",
				"Dashoffset": "Dashoffset",
				"Initial_gap": "Initial gap",
				"Gap": "Gap",
				"Halo": "Halo",
				"Radius": "Radius",
				"AnchorPoint": "AnchorPoint",
				"Is_aligned": "Is aligned",
				"Is_repeated": "Is repeated",
				"Perpendicular_offset": "Perpendicular offset",
				"Graphic_references": "Graphic references",
				"None": "None",
				"Custom": "Custom",
				"Linecap": "Linecap",
				"Graphic": "Graphic",
				"File": "File",
				"Linejoin": "Linejoin",
				"Database": "Use database value.",
				"Select_a_file": "Select a file",
				"Upload_a_file": "Upload",
				"FileUploadError": "Could not upload file",
				"FileDeleteError": "Could not delete file",
				"Select_field": "Select field",
				"Delete_custom_Rule": "Deletes all changes, rule will again be influenced by default rule",
				"Unlock_Rule": "Allows edit. <b>Warning </b>: Changes in default rule will no longer influence this rule!",
				"ShowBigPreview": "Show maximized preview.",
				"HideBigPreview": "Hide maximized preview.",
				"Unlock_SymbologyType": "Allows you to set symbology type manually.",
				"Lock_SymbologyType": "Symbology type will be set automatically.",
				"SymbologyType": "Symbology type",
				"Symbolizer": "Symbolizer",
				"SymbolLoadError": "Error loading symbols",
				"From": "From",
				"To": "To",
				"Scale": "Scale",
				"Search": "Search",
				"Filter": "Filter",
				"Rule": "Rule",
				"No_suggestion": "No suggestion.",
				"Loading_data": "Loading data",
				"Unstyled_Layer": "Unstyled"
			}
		},
		"RiaClient": {
			"Titles": {
				"LayerTree": "Layer tree",
				"MeasureTool": "Measure tool",
				"Effects": "Effects",
				"CameraControl": "Camera",
				"SaveState": "Save state (hold CTRL to clear)",
				"Locate": "Locate",
				"ZoomIn": "Zoom-in",
				"ZoomOut": "Zoom-out",
				"MouseLocation": "Mouse location",
				"LeavePanorama": "Leave Panorama View"
			},
			"LayerTree": {
				"Title": "Map layers",
				"Actions": {
					"FitToData": "Fit to data",
					"ToggleLayerVisibility": "Toggle layer visibility",
					"ToggleBaseLayer": "Toggle base layer",
					"CantFitToData": "Cannot fit to layer"
				}
			},
			"MeasureTool": {
				"Title": "Measurement tool",
				"Labels": {
					"MeasureMode": "Measure mode",
					"Off": "Off",
					"Distance": "Distance",
					"Height": "Height",
					"Orthogonal": "Orthogonal",
					"Area": "Area",
					"TotalDistance": "Total Distance",
					"TotalArea": "Total Area"
				}
			},
			"CameraControl": {
				"Title": "Camera",
				"Labels": {
					"DefaultCamera": "Default Camera",
					"FirstPersonCamera": "First Person Camera"
				}
			},
			"EffectsPanel": {
				"ambientOcclusion": "Ambient Occlusion",
				"aoPower": "Power",
				"aoRadius": "Radius",
				"antiAliasing": "Anti Aliasing",
				"atmosphere": "Atmosphere",
				"depthOfField": "Depth Of Field",
				"dofFocalDepth": "Focal Depth",
				"dofFocusRange": "Focus Range",
				"dofNoFocusRange": "No Focus Range",
				"dofScale": "Scale",
				"eyeDomeLighting": "Eyedome Lighting",
				"edlColor": "Color",
				"edlStrength": "Strength",
				"edlWindow": "Window",
				"headLight": "Head Light",
				"hlAmbientColor": "Ambient Color",
				"hlDiffuseColor": "Diffuse Color",
				"sunLight": "Sun Light",
				"slAmbientColor": "Ambient Color",
				"slDiffuseColor": "Diffuse Color",
				"slShadows": "Shadows",
				"slUseLiveTime": "Use current time",
				"slTime": "Time",
				"slDate": "Date",
				"slTimezone": "Timezone",
				"starfield": "Starfield"
			}
		},
		"AppEngine": {
			"AnalyzerView": "Analyzer view",
			"ApplicationType": "Application type",
			"Bounds": "Bounds",
			"CodeSnippets": "Code snippets",
			"Crs": "CRS",
			"Legend": "Legend",
			"Loading": "loading",
			"Markup": "Markup",
			"NoScriptWarning": "Preview only, scripts won't be executed",
			"Script": "Script",
			"SelectConfig": "Select config",
			"Style": "Style",
			"StyleSet": "Styleset",
			"Vector": "Vector",
			"Snippets": {
				"Communication": {
					"Title": "Communication",
					"WaitAllPanelLoad": "Wait for all panels to load",
					"SendMessageToAllPanels": "Send message to all panels",
					"ListenToOtherPanels": "Listen to messages from other panels",
					"ListToSpecificPanel": "Listen to messages from a specific panel",
					"SendFunctionToOtherPanels": "Send a function to another panels"
				},
				"Utility": {
					"Title": "Utility",
					"LoadThirdPartyLibs": "Load external libraries"
				},
				"PointCloud": {
					"Title": "Point Cloud",
					"PointCloudStyle": "Point Cloud Styling"
				},
				"Layer": {
					"Title": "Layer",
					"FindLayerByLabel": "Find layer by label",
					"FilterLayerByType": "Filter layer by type",
					"ShowHideLayer": "Show/hide layer",
					"CreateWmsLayer": "Create WMS layer"
				},
				"MaeInterface": {
					"Title": "MAE Interface",
					"OpenWorkflow": "Open a workflow",
					"PerformQuery": "Perform a query",
					"PerformTypedQuery": "Perform a query with a typed result",
					"PerformCSVQuery": "Perform a query, CSV result",
					"PerformGeoJSONQuery": "Perform a geoJson query",
					"LoadExternalScript": "Load an external library"
				},
				"Map": {
					"Title": "Map",
					"MapInformation": "Read map information",
					"PanToPoint": "Pan to point",
					"PanToBounds": "Pan to bounds",
					"Zoom": "Zoom in/out",
					"Draw3DFeature": "Draw 3D feature",
					"AddCopyright": "Add a copyright notice"
				},
				"Recipes": {
					"Title": "Recipes",
					"ListenProcessStart": "Listen for process start",
					"ListenProcessStatusUpdate": "Listen for process status update",
					"ListenProcessFinish": "Listen for process finish",
					"GetProcessOutputs": "Get process outputs",
					"RegisterPreprocessor": "Register preprocessor",
					"SendOutputToMapView": "Send geoprocessing raster output to a Map View panel"
				},
				"Transformation": {
					"Title": "Transformations",
					"RegisterCRS": "Register a custom coordinate system",
					"PointTransformation": "Point transformation",
					"BoundsTransformation": "Bounds transformation",
					"ShapeTransformation": "Shape transformation"
				},
				"Vector": {
					"Title": "Vector",
					"EventHandlerSelectionChanged": "Add event handler for SelectionChanged event",
					"CreateCustomPainter": "Create a custom painter"
				}
			}
		}
	}
};
export var DefaultLocalization: ILocalization = {
	"Abort": "Abort",
	"Actions": "Actions",
	"Add": "Add",
	"AddFilter": "Add Filter",
	"All": "All",
	"Apply": "Apply",
	"Cache": "Cache",
	"Cancel": "Cancel",
	"Clear": "Clear",
	"ClearAll": "Clear All",
	"Close": "Close",
	"Column": "Column",
	"Columns": "Columns",
	"Date": "Date",
	"Delete": "Delete",
	"Deleted": "Deleted",
	"DeletedAll": "Deleted All",
	"Description": "Description",
	"Download": "Download",
	"Downloaded": "Downloaded",
	"Edit": "Edit",
	"End": "End",
	"EndDate": "End Date",
	"Error": "Error",
	"Filter": "Filter",
	"FilterTitle": "FILTER",
	"General": "GENERAL",
	"Id": "Id",
	"Import": "Import",
	"Invalid": "Invalid",
	"Items": "Items",
	"Launch": "Launch",
	"Live": "Live",
	"Message": "Message",
	"Name": "Name",
	"New": "New",
	"No": "No",
	"Now": "Now",
	"NoItemFilter": "NO ITEM MATCHES FILTER CONDITIONS",
	"NoItems": "NO ITEMS",
	"Notification": "Notification",
	"Off": "Off",
	"Ok": "Ok",
	"On": "On",
	"Preview": "Preview",
	"Publish": "Publish",
	"Refresh": "Refresh",
	"Reset": "Reset",
	"Restore": "Restore",
	"AvailableUpdates": "Updates available",
	"Remove": "Remove",
	"Roles": "Roles",
	"Save": "Save",
	"Saved": "Saved",
	"Search": "Search",
	"SRID": "EPSG",
	"Start": "Start",
	"Stats": "Stats",
	"Submit": "Submit",
	"Sync": "Sync",
	"Table": "Table",
	"Time": "Time",
	"Title": "Title",
	"Today": "Today",
	"Upload": "Upload",
	"User": "User",
	"Valid": "Valid",
	"Value": "Value",
	"Yes": "Yes",
	"Created": "Created",
	"Hour": "Hour",
	"Day": "Day",
	"Week": "Week",
	"From": "From",
	"To": "To",
	"Color": "Color",
	"CSV": "CSV",
	"Type": "Type",
	"Progress": {
		"Uploading": "Uploading...",
		"Columns": "Columns...",
		"ChooseFilter": "Choose Filter Operator...",
		"PleaseWait": "Please wait...",
		"Loading": "Loading...",
		"Redirect": "Redirect...",
		"Login": "Login...",
		"SendingRequest": "Sending request...",
		"Validating": "Validating...",
		"Select": "Select...",
		"Saving": "Saving...",
		"Imagery": "Processing imagery...",
		"TestQuery": "Testing Query...",
		"Refreshing": "Refreshing..."
	},
	"License": {
		"Enterprise": "ENTERPRISE",
		"InvalidAccount": "This system is using an invalid license! Please contact your System administrator or Hexagon Geospatial.<br/>By using the system you are in violation of the End-User-License-Agreement (EULA) and your license is subject to termination.",
		"LicensedTo": "Licensed to",
		"MApp": "M.App",
		"MApps": "M.APPS",
		"ServiceDown": "Usage statistics cannot be synchronized, because the service is not running or lost connectivity.",
		"FeatureRequiresPro": "This feature requires a Professional license"
	},
	"Errors": {
		"AccessDenied": "Access denied!",
		"Activation": "Activation Error!",
		"DatabaseNoConnection": "Can not connect to database.",
		"LoginIncorrect": "The user name or password is incorrect!",
		"MissingTenant": "Missing Tenant!",
		"NotFound": "Not Found!",
		"NotImplemented": "Not implemented!",
		"NoValidationServer": "Could not validate. Internal server error.",
		"Occured": "An error occurred!",
		"PasswordMismatch": "Password pattern is not matched.",
		"Invalid": "Invalid!",
		"Transformation": "Transformation failed",
		"CrsFromExisting": "CRS From Existing failed",
		"ImportVectorData": "An error occured while importing vector data! Please define the caching information manually.",
		"Action": "-Invalid Name-",
		"UnknownLocationType": "Unknown Location Type",
		"UnknownActionType": "Unknown Action Type",
		"Validation": "Validation Error!",
		"Query": "Could not validate query definition.",
		"UnknownAppType": "AppType unknown or not implemented.",
		"Send": "Sending failed.",
		"MissingHexagonAppLauncher": {
			"Title": "App not opening?",
			"HintStart": "Make sure you have",
			"HexagonAppLauncher": "Hexagon App Launcher",
			"HintEnd": "installed."
		},
		"WrongPassword": "Wrong password. Please try again.",
		"MissingPassword": "Please enter current password.",
		"ProvidedPasswordInvalid": "Provided password is not valid. Please try again.",
		"ProvidedPasswordsDontMatch": "Provided passwords do not match. Please try again.",
		"ProvidedEmailInvalid": "Provided email is not valid. Please try again."
	},
	"Login": {
		"ChangePassword": "Change password",
		"EnableTwoFactor": "Enable two factor authentication",
		"DisableTwoFactor": "Disable Two Factor Authentication",
		"QrCode": "Scan QR Code with an authenticator app (e.g.: Google Authenticator, Microsoft Authenticator, ...)",
		"EnterToken": "Enter token*",
		"ConfirmPassword": "Password confirm",
		"CurrentPassword": "Current password",
		"Email": "Email",
		"ForgotPassword": "Forgot password?",
		"Guest": "Guest",
		"HidePassword": "Hide Password",
		"InstructionMail": "We will send you an email with instructions to reset your password",
		"Login": "Login",
		"LoginButton": "Login",
		"Logout": "LOGOUT",
		"NewPassword": "New password",
		"NewPasswordConfirm": "New password confirm",
		"Password": "Password",
		"ResetPassword": "Reset password",
		"SendingDone": "An email has been sent to reset the password",
		"SendingFailed": "Could not send mail to user!",
		"Settings": "SETTINGS",
		"Username": "Username",
		"Welcome": "Welcome",
		"Authorization": "Authorization",
		"Activated": "Activated",
		"Pattern": "Pattern",
		"Passwords": "PASSWORDS",
		"Fullname": "Fullname",
		"Token": "Token"
	},
	"Confirm": {
		"Delete": {
			"Singular": "Are you sure you want to delete this item?",
			"Plural": "Are you sure you want to delete these items?",
			"CustomCrsWarningSingular": "Deleting this CRS will invalidate all related objects. Are you sure?",
			"CustomCrsWarningPlural": "Deleting these CRS will invalidate all related objects. Are you sure?",
			"Warning": "Warning"
		},
		"UnsavedChanges": "All unsaved changes will be discared.<br/>Are you sure you want to cancel?",
		"LoggedOut": "You will be logged out automatically.<br/>Are you sure you want to proceed?",
		"General": "Are you sure?"
	},
	"Activation": {
		"Activate": "Activate",
		"Charge": "Charge",
		"DefinePassword": "Choose a password to activate new user.",
		"ReActivate": "Re-activate user",
		"SendActivation": "Send account activation mail to {0}?",
		"ActivationSent": "Activation mail has been sent to {0}"
	},
	"Studio": {
		"Stats": {
			"Dataset": "Dataset Type Stats",
			"Vector": "Vector Type Stats",
			"Content": "Content Type Stats",
			"GoToApps": "Go to Apps Page"
		},
		"Tools": "TOOLS",
		"Security": "SECURITY",
		"Content": "CONTENT",
		"Cache": "CACHE",
		"ActiveDirectory": {
			"ActiveDirectory": "ACTIVE DIRECTORY",
			"Imported": "Imported",
			"AzurePermissionsMissing": "Missing Azure Permissions"
		},
		"Image": "IMAGE",
		"ApiKey": {
			"ApiKeys": "API KEYS",
			"Note": "NOTE",
			"NoteText": "Treat your tokens like passwords and keep them secret.",
			"Token": "Token"
		},
		"Desktop": {
			"Desktop": "DESKTOP"
		},
		"Query": {
			"Queries": "QUERIES",
			"ChooseQueryDataset": "Choose Query Dataset",
			"ChooseDisplayDataset": "Choose Display Dataset",
			"SqlQuery": "SQL Query",
			"TestQuery": "Test Query",
			"QueryValid": "Query definition is valid."
		},
		"PrintLayout": {
			"PrintLayouts": "PRINT LAYOUTS",
			"PrintLayout": "PRINT LAYOUT",
			"PrintLayoutLabel": "Print Layout",
			"Editor": "PRINT LAYOUT EDITOR"
		},
		"OverView": {
			"OverViews": "OVERVIEWS",
			"OverView": "OVERVIEW",
			"Name": "Name of Overview"
		},
		"ActionSet": {
			"Locations": {
				"Grid": "Data Grid",
				"Left": "Sidebar",
				"Frame": "Frame"
			},
			"Location": "Location",
			"TopAction": "TopAction",
			"Hidden": "Hidden",
			"DataGrid": "Data Grid",
			"Context": "Context",
			"ActionSets": "ACTION SETS",
			"ActionSet": "Action Set",
			"ActionSetTitle": "ACTION SET",
			"StartOnLoad": "Start On Load",
			"Tooltip": "Tooltip",
			"Icon": "Icon",
			"ChooseImage": "Choose Image",
			"ActiveLayer": "Active Layer",
			"ChooseActiveLayer": "Choose Active Layer",
			"ActiveLayerRequired": "Active Layer Required",
			"MinSelection": "Min. Selection",
			"MaxSelection": "Max. Selection",
			"Target": "Target",
			"Width": "Width",
			"Height": "Height",
			"Blocking": "Blocking",
			"ViewSize": "View Size",
			"ViewSizes": {
				"Default": "Default",
				"Half": "Half",
				"Extended": "Extended",
				"Full": "Full"
			},
			"Url": "Url",
			"Workflow": "Workflow",
			"ChooseWorkflow": "Choose Workflow",
			"Node": "Node",
			"BrowserUrl": "Browser (Url)",
			"BrowserTarget": "Browser (Target)",
			"OpenFile": "Open File",
			"Top": "Top",
			"ActionGroup": "Action Group",
			"ValidationError": "Validation Error"
		},
		"VectorData": {
			"VectorData": "VECTOR DATA",
			"Caching": "Caching",
			"Import": "Import Vector",
			"Geometry": "Geometry",
			"Snapable": "Snapable",
			"BufferSizeFactor": "Buffersize Factor",
			"Interpretation": "Interpretation",
			"Vector": "Vector",
			"GeometryType": "Geometry Type",
			"Dimension": "Dimension",
			"Refresh": {
				"Progress": "Please wait while the meta information is getting refreshed.",
				"Success": {
					"Title": "The refreshing process is successfully completed.",
					"Text": "All corresponding cached data are getting subsequently updated now."
				},
				"Redirect": {
					"HintStart": "Click",
					"HintLink": "here",
					"HintEnd": "to view the progress state."
				},
				"Fail": "An error occured while trying to refresh the meta information.",
				"Label": "Refresh geometry information"
			}
		},
		"Imagery": {
			"Imagery": "IMAGERY",
			"Path": "Path",
			"Wms": "WMS",
			"SelectType": "Select at least one service type.",
			"Wmts": "WMTS",
			"Ecwp": "ECWP",
			"Wfs": "WFS",
			"Here": "HERE Maps"
		},
		"Geoservice": {
			"Geoservices": "GEOSERVICES",
			"MinScale": "Min. Scale",
			"MaxScale": "Max. Scale",
			"Format": "Format",
			"AppCode": "App Code",
			"AppId": "App ID",
			"ApiKey": "API Key",
			"MapType": "Type",
			"MapTileType": "Tile Type",
			"LanguageCode": "Language",
			"DualLanguageCode": "Second Language",
			"TileMatrix": "TileMatrix",
			"ServiceType": "Service Type",
			"Error": {
				"CannotConnect": "Cannot connect to service",
				"CheckLogs": "Please check the logs for more information"
			},
			"Modal": {
				"Title": "GeoService endpoint URLs",
				"CopyURLToClipBoard": "Copy endpoint URL to clipboard",
				"ShowEndpointURLS": "Show endpoint URLs",
				"Notification": "Endpoint URL has been copied to your clipboard!",
				"NotPublished": "Not yet published"
			}
		},
		"Copyright": {
			"Copyrights": "COPYRIGHTS",
			"Text": "Copyright Text",
			"Assigned": "Assigned copyright"
		},
		"AttributeData": {
			"AttributeData": "ATTRIBUTE DATA",
			"Attribute": "Attribute",
			"Attributes": "Attributes",
			"Type": "Type",
			"Import": "Import Attribute data",
			"KeyField": "Key Field"
		},
		"Order": {
			"Orders": "ORDERS",
			"State": "State",
			"Progress": "Progress",
			"Message": "Message"
		},
		"Recipe": {
			"Recipes": "RECIPES"
		},
		"StyleSet": {
			"StyleSets": "STYLESETS",
			"Style": "Style",
			"Styles": "Styles",
			"VectorLayer": "Vector Layer",
			"GeometryType": "Geometry Type",
			"Styled": "Styled",
			"LaunchNewEditor": "Launch in new Style Editor"
		},
		"Role": {
			"Roles": "ROLES",
			"Role": "Role",
			"RolesLabel": "Roles"
		},
		"App": {
			"App": "App",
			"Apps": "Apps"
		},
		"Legend": {
			"Name": "Legend Name",
			"Legend": "LEGEND",
			"LegendAction": "Legend",
			"NameLayer": "Name of Layer",
			"NameTheme": "Name of Theme",
			"Legends": "LEGENDS",
			"AddTheme": "Add Theme",
			"LegendLabel": "Legend",
			"CannotDropOutsideTree": "Cannot drop outside of tree.",
			"DragDropDataset": "Drag & Drop Datasets here.",
			"DropInvalidNode": "Cannot drop invalid node.",
			"LayersNoSubLayers": "Layers cannot have sublayers.",
			"ThemesAboveLayers": "Themes must be placed above layers on the same level.",
			"LayersAboveBasemaps": "Layers must be placed above Basemaps.",
			"LayersBelowThemes": "Layers must be placed below themes on the same level"
		},
		"MyGeoservice": {
			"Service": "Service",
			"MyGeoservices": "MY GEOSERVICES",
			"MyGeoservice": "My GeoService",
			"MyGeoservicesButton": "My GeoServices",
			"FusionGeoService": "Fusion GeoServices",
			"Depth": "Depth",
			"StyleSet": "Choose Style Set",
			"ApiKey": "Secure with API Key",
			"WmsSettings": "WMS SETTINGS",
			"SingleLayer": "Single Layer",
			"WmtsSettings": "WMTS SETTINGS",
			"OnDemand": "OnDemand",
			"Scale": "Scale",
			"WfsSettings": "WFS SETTINGS",
			"MaxNumFeatures": "Maximum feature count"
		},
		"Dataset": {
			"Dataset": "Dataset",
			"Datasets": "DATASETS",
			"DatasetsLabel": "Datasets",
			"Vectorsets": "VECTOR SETS",
			"Vectorset": "Vector Set",
			"Layer": "Layer",
			"Layers": "Layers",
			"Feature": "Feature"
		},
		"MapView": {
			"MapViews": "MAP VIEWS",
			"West": "West",
			"East": "East",
			"North": "North",
			"South": "South",
			"Name": "Name",
			"EPSG": "EPSG",
			"Bounds": "Bounds",
			"AutoBoundsSet": "Bounds set from map",
			"AutoBoundsError": "Could not fetch bounds from map",
			"AutoBoundsDisabled": "Enable Preview to fetch bounds from map",
			"BoundsModeManual": "Manual",
			"BoundsModeAuto": "Auto",
			"NoPitchInManual": "Cannot pitch camera in Manual Mode",
			"StyleSets": "StyleSet",
			"Legend": "Legend",
			"PanToLayer": "Pan to Layer",
			"EnableToPan": "Enable Preview to pan to use panning",
			"UnlockBounds": "Unlock bounds from map",
			"LockBounds": "Lock bounds to map",
			"PanToBounds": "Pan to bounds",
			"ViewerOptions": "Viewer Options",
			"LayerTree": "Layer Tree",
			"ZoomTool": "Zoom Tool",
			"PanTool": "Pan Tool",
			"MeasureTool": "Measure Tool",
			"Preview": "Preview",
			"NoLegend": "No legend selected",
			"NoLayers": "No layers in selected legend",
			"NoEpsg": "No valid EPSG selected",
			"LoadError": "Could not load MapView with id ",
			"LoadDataError": "Could not load data",
			"EnablePreview": "Enable Preview",
			"Render3D": "Render 3D Map",
			"Effects": "Effects",
			"MouseCoordinates": "Mouse coordinates",
			"CameraSettings": "Camera settings"
		},
		"Job": {
			"Jobs": "JOBS",
			"Repeat": "Repeat",
			"Every": "Every",
			"Interval": "Interval",
			"SwitchingSource": "Switching source",
			"Switch": "Switch",
			"SwitchMessage": "There are some selected items in the current table.<br/>If you switch to another source table you will lose your selection.",
			"Next": "Next"
		},
		"Epsg": {
			"Bounds": "Bounds",
			"TransformBounds": "Transform Bounds",
			"NewEpsg": "New EPSG",
			"Epsg": "EPSG",
			"TransformButton": "Transform",
			"Crs": "CRS",
			"CustomCrs": "CUSTOM CRS",
			"FromExisting": "From Existing",
			"Wkt": "Well Known Text (WKT 2)",
			"AreaOfUse": "AREA OF USE",
			"AbridgedTransfromation": "ABRIDGED TRANSFORMATION",
			"TranslateX": "Translate X",
			"TranslateY": "Translate Y",
			"TranslateZ": "Translate Z",
			"RotateX": "Rotate X",
			"RotateY": "Rotate Y",
			"RotateZ": "Rotate Z",
			"ScaleDifference": "Scale Difference"
		},
		"Browser": "BROWSER",
		"Connection": {
			"Connection": "Connection",
			"Database": "Database",
			"Datasource": "Data Source",
			"Host": "Host",
			"InitialCatalog": "Initial Catalog",
			"Oracle": "Oracle",
			"Port": "Port",
			"PostgreSQL": "PostGIS",
			"Hana": "Hana",
			"Server": "Server",
			"Provider": "Provider",
			"Section": "CONNECTIONS",
			"Source": "Source",
			"SqlServer": "Microsoft SQL Server"
		},
		"FeatureAnalyzer": "Feature Analyzer",
		"AnalyzerViews": "ANALYZER VIEWS",
		"OpenEditor": "Open in editor",
		"WorkflowEditor": "Workflow Editor",
		"Workflows": "WORKFLOWS",
		"User": {
			"UsersTitle": "USERS",
			"User": "User",
			"Users": "Users",
			"Activation": {
				"Resend": "Resend activation"
			},
			"BrandingUpdate": "Branding colors updated.",
			"BrandingError": "Branding colors could'nt be saved.",
			"SettingsUpdate": "User settings updated.",
			"StudioAccount": "Studio Account",
			"TwoFactor": "Two Factor",
			"IsTwoFactorActivated": "Two Factor Activated?",
			"IsTwoFactorRequired": "Require Two Factor?",
			"LanguageCode": "Language",
			"Theming": "Theming",
			"AutomaticTheming": "Automatic theming",
			"DarkMode": "Darkmode",
			"ConfirmResetDefaults": "Restore defaults colors",
			"EnterNewEmail": "New email*",
			"EnterNewLanguage": "New language*",
			"EnterCurrentPassword": "Current password*"
		},
		"Publish": {
			"Vector": "Publish Vector",
			"Wmts": "Publish Wmts",
			"ClearCache": "Clear Wmts Cache",
			"CacheCleared": "Cache cleared"
		},
		"Area": {
			"Area": "AREA",
			"ImportArea": "Import Areas",
			"Import": "Import",
			"AreaNamePattern": "Name Pattern",
			"ChooseDataset": "Choose Dataset"
		},
		"DataSource": {
			"DataSource": "DATASOURCE",
			"DataSources": "DATASOURCES",
			"ConnectionString": "Connection String",
			"NewConnection": "New Connection"
		},
		"FusionData": {
			"FusionData": "3D DATA",
			"ServiceType": {
				"Elevation": "ELEVATION",
				"Ogc3dTile": "OGC 3D TILES",
				"Panoramics": "PANORAMICS"
			},
			"Endpoint": "Endpoint",
			"QualityFactor": "Quality Factor",
			"TerrainOffset": "Terrain Offset",
			"FusionImport": "Fusion Import",
			"FusionStudio": "FUSION STUDIO",
			"PartOfTerrain": "Part of terrain"
		},
		"DeviceLogs": "DEVICE LOGS",
		"Shell": "SHELL",
		"ShellLabel": "Shell",
		"Mobile": "MOBILE",
		"IsAreaRequired": "Area required?",
		"Branding": {
			"BrandingLabel": "BRANDING",
			"BrandingColors": "BRANDING COLORS",
			"ColorPalette": "COLOR PALETTE",
			"PrimaryColor": "Primary*",
			"SecondaryColor": "Secondary",
			"PleaseEnterHex": "Please enter a hex color code.",
			"RestoreDefaults": "Restore defaults",
			"OverwriteDefaults": "Overwrite default colors",
			"Preview": "Preview",
			"RestoreDialogMessage": "Are you sure you want to restore the default color settings?",
			"ColorPresets": "Color presets"
		}
	},
	"Management": {
		"Charges": "CHARGES",
		"Logs": "LOGS",
		"Tenants": "TENANTS",
		"TenantsField": "Tenants",
		"Session": "Session",
		"Usage": {
			"Usage": "USAGE",
			"PurchasedHours": "Purchased hours",
			"HoursUsed": "Hours used",
			"RemainingHours": "Remaining hours",
			"HoursCharacter": "h",
			"Hours": "Hours"
		},
		"Languages": {
			"Languages": "LANGUAGES",
			"AvailableLanguages": "Available Languages",
			"Code": "Code",
			"CompletedTranslationPercentage": "Translation status (%)",
			"Language": "Language"
		},
		"Prediction": "PREDICTION",
		"Overview": "OVERVIEW",
		"Environment": "Environment",
		"ProductType": "Type",
		"StudioAccount": "STUDIO ACCOUNT",
		"DomainOptional": "DOMAIN (OPTIONAL)",
		"ActiveDirectoryOptional": "ACTIVE DIRECTORY INTEGRATION (OPTIONAL)",
		"None": "None",
		"AzureActiveDirectory": "Azure",
		"WsFederation": "WS-Federation",
		"ActiveDirectory": "Active Directory",
		"OpenIdConnect": "OpenID Connect",
		"ClientId": "Client ID",
		"TenantId": "Tenant ID",
		"ClientSecret": "Client Secret",
		"adUsername": "AD Username",
		"adPassword": "AD Password",
		"adPath": "AD Path",
		"Domain": "Domain",
		"Type": "Type",
		"UseAD": "Use Active Directory",
		"OpenStudio": "Open Studio",
		"TwoFactorAuthentication": "TWO FACTOR AUTHENTICATION",
		"OpenIdConnectClientId": "Client Id",
		"OpenIdConnectClientSecret": "Client Secret (optional)",
		"OpenIdConnectGroupsClaim": "Groups Claim (optional)",
		"OpenIdConnectDiscoveryUrl": "Discovery Url",
		"OpenIdConnectAuthUrl": "Auth Url",
		"OpenIdConnectTokenUrl": "Token Url",
		"OpenIdConnectUserInfoUrl": "User Info Url",
		"PreferThirdPartyLogin": "Prefer third party login?"
	},
	"Validation": {
		"Ok": "Ok.",
		"Saving": "Saving...",
		"DatasetNameExists": "Dataset Name already exists.",
		"isValidName": "Name too long or invalid. (Allowed: a-zA-Z_0-9)",
		"isValidTitle": "Name too long or invalid characters.",
		"isValidUsername": "Username too long or invalid characters.",
		"lessThanDigit": "Value has to be less than {0}.",
		"greaterThanDigit": "Value has to be greater than {0}.",
		"email_v2": "Email is not valid.",
		"atLeastOne": "Select at least one item.",
		"required": "This field is required.",
		"min": "Please enter a value greater than or equal to {0}.",
		"max": "Please enter a value less than or equal to {0}.",
		"minLength": "Please enter at least {0} characters.",
		"maxLength": "Please enter no more than {0} characters.",
		"pattern": "Please check this value.",
		"step": "The value must increment by {0}.",
		"email": "Please enter a proper email address.",
		"date": "Please enter a proper date.",
		"dateISO": "Please enter a proper date.",
		"number": "Please enter a number.",
		"digit": "Please enter a digit.",
		"phoneUS": "Please specify a valid phone number.",
		"equal": "Values must equal.",
		"notEqual": "Please choose another value.",
		"unique": "Please make sure the value is unique.",
		"greaterThanMaxNumber": "Value exceeds the valid value range.",
		"lessThanMinNumber": "Value falls below the valid value range.",
		"legendMissing": "Missing Legend.",
		"tilingInfoMissing": "Missing tile info.",
		"layerBoundsOutside": "Layer bounds outside of CRS bounds.",
		"keyFieldMissing": "KeyField is missing.",
		"appConfigMissing": "Missing App Configuration.",
		"childIsInvalid": "One child element is invalid.",
		"missingCRS": "SRID is not valid",
		"dataSourceMissing": "Missing data source.",
		"shellMissing": "Missing shell.",
		"fileSize": "The file size exceeds the limit allowed ({0}) and cannot be saved.",
		"shellXamlMissing": "Missing Shell.xaml in top level.",
		"vectorSetIsEmpty": "VectorSet is empty.",
		"TransformBoundsError": "Could not transform bounds from SRID {0} to SRID {1}."
	},
	"Apps": {
		"StyleEditor": {
			"Button": {
				"Add_symbolizer": "Add symbolizer",
				"Add_rule": "Add rule",
				"Bind_DB": "Bind to database column",
				"Delete_rule": "Delete rule",
				"Delete_symbolizer": "Delete symbolizer",
				"Delete_style": "Delete style",
				"Pan_To_Layer": "Pan to layer",
				"Hide_Layer": "Hide layer",
				"Make_Layer_Permanent": "Make layer permanent",
				"No_Bounds": "No bounds information available",
				"Point_placement": "Point placement",
				"Expert_point_placement": "Expert point placement",
				"Line_placement": "Line placement"
			},
			"Hints": {
				"NoStyleSelected": "No style selected",
				"RefreshNecessary": "Saving of styleset necessary to get database value for this field",
				"InvalidExternalReference": "Invalid external reference",
				"ContainsInvalidExternalReference": "Contains invalid external reference"
			},
			"Wizards": {
				"ColorScheme": "Color scheme",
				"Categories": "Categories",
				"Distribution": "Distribution",
				"Classes": "Classes",
				"Field": "Field",
				"Style": "Style",
				"Hints": {
					"MostRelevantHint": "Most relevant values selected automatically due to selected db field containing more than 10 distinct values.",
					"LessThanThreeHint": "Selected database field contains less than 3 distinct values. Categorization not supported.",
					"NoDBFieldsAvailable": "No db fields available for selected style",
					"ClassifyOnlyForNumericValues": "Caution: Generating classified rules is only possible for numeric values",
					"MoreThan50Categories": "Caution: Color generation is only available for up to 54 categories. More colors have to be selected manually"
				},
				"Errors": {
					"DbFieldsCouldNotBeFetched": "Error: Database fields could not be fetched.",
					"ValuesofDbfieldsCouldnotBeFetched": "Error: Values of field could not be fetched."
				}
			},
			"FileUploadComponent": {
				"NoFileSelected": "-- No file selected --",
				"InvalidReferencePleaseCheck": "-- Invalid reference, please check --",
				"NoFilesAvailable": "-- No files available. Please upload --"
			},
			"General": {
				"Text": "Text",
				"Simple": "Simple",
				"Expert": "Expert",
				"Simple_fill": "Simple fill",
				"Graphic_fill_filled_mark": "Graphic fill | Filled mark",
				"Graphic_fill_stroked_mark": "Graphic fill | Stroked mark",
				"Graphic_fill_stroked_and_filled_mark": "Graphic fill | Filled & Stroked mark",
				"Graphic_fill_external_graphic": "Graphic fill | External graphic",
				"Custom_fill": "Custom Fill",
				"Stroked_mark": "Stroked mark",
				"Filled_mark": "Filled mark",
				"Filled_and_stroked_mark": "Filled & Stroked mark",
				"External_graphic": "External graphic",
				"Custom_halo": "Custom Halo",
				"Custom_graphic": "Custom graphic",
				"Simple_line": "Simple line",
				"Dashed_line": "Dashed line",
				"Graphic_stroke_Stroked_mark": "Graphic stroke | Stroked mark",
				"Graphic_stroke_Filled_mark": "Graphic stroke | Filled mark",
				"Graphic_stroke_FilledAndStroked_mark": "Graphic stroke | Filled & Stroked mark",
				"Graphic_stroke_External_graphic": "Graphic stroke | External graphic",
				"Left": "Left",
				"Bottom": "Bottom",
				"Right": "Right",
				"Top": "Top",
				"Center": "Center",
				"Square": "Square",
				"Circle": "Circle",
				"Triangle": "Triangle",
				"Cross": "Cross",
				"Star": "Star",
				"Unit": "Unit",
				"Fill": "Fill",
				"Fill_color": "Fill color",
				"Fill_opacity": "Fill opacity",
				"Stroke": "Stroke",
				"Stroke_width": "Stroke width",
				"Stroke_color": "Stroke color",
				"Stroke_opacity": "Stroke opacity",
				"Name": "Name",
				"Label_text": "Label text",
				"Horizontal": "Horizontal",
				"Vertical": "Vertical",
				"Label_placement": "Label placement",
				"Graphic_size": "Graphic size",
				"Graphic_fill": "Graphic fill",
				"Font_family": "Font family",
				"Font_size": "Font size",
				"Font_weight": "Font weight",
				"Font_style": "Font style",
				"Opacity": "Opacity",
				"Rotation": "Rotation",
				"Displacement_X": "Displacement X",
				"Displacement_Y": "Displacement Y",
				"Marktype": "Marktype",
				"Dasharray": "Dasharray",
				"Dashoffset": "Dashoffset",
				"Initial_gap": "Initial gap",
				"Gap": "Gap",
				"Halo": "Halo",
				"Radius": "Radius",
				"AnchorPoint": "AnchorPoint",
				"Is_aligned": "Is aligned",
				"Is_repeated": "Is repeated",
				"Perpendicular_offset": "Perpendicular offset",
				"Graphic_references": "Graphic references",
				"None": "None",
				"Custom": "Custom",
				"Linecap": "Linecap",
				"Graphic": "Graphic",
				"File": "File",
				"Linejoin": "Linejoin",
				"Database": "Use database value.",
				"Select_a_file": "Select a file",
				"Upload_a_file": "Upload",
				"FileUploadError": "Could not upload file",
				"FileDeleteError": "Could not delete file",
				"Select_field": "Select field",
				"Delete_custom_Rule": "Deletes all changes, rule will again be influenced by default rule",
				"Unlock_Rule": "Allows edit. <b>Warning </b>: Changes in default rule will no longer influence this rule!",
				"ShowBigPreview": "Show maximized preview.",
				"HideBigPreview": "Hide maximized preview.",
				"Unlock_SymbologyType": "Allows you to set symbology type manually.",
				"Lock_SymbologyType": "Symbology type will be set automatically.",
				"SymbologyType": "Symbology type",
				"Symbolizer": "Symbolizer",
				"SymbolLoadError": "Error loading symbols",
				"From": "From",
				"To": "To",
				"Scale": "Scale",
				"Search": "Search",
				"Filter": "Filter",
				"Rule": "Rule",
				"No_suggestion": "No suggestion.",
				"Loading_data": "Loading data",
				"Unstyled_Layer": "Unstyled"
			}
		},
		"RiaClient": {
			"Titles": {
				"LayerTree": "Layer tree",
				"MeasureTool": "Measure tool",
				"Effects": "Effects",
				"CameraControl": "Camera",
				"SaveState": "Save state (hold CTRL to clear)",
				"Locate": "Locate",
				"ZoomIn": "Zoom-in",
				"ZoomOut": "Zoom-out",
				"MouseLocation": "Mouse location",
				"LeavePanorama": "Leave Panorama View"
			},
			"LayerTree": {
				"Title": "Map layers",
				"Actions": {
					"FitToData": "Fit to data",
					"ToggleLayerVisibility": "Toggle layer visibility",
					"ToggleBaseLayer": "Toggle base layer",
					"CantFitToData": "Cannot fit to layer"
				}
			},
			"MeasureTool": {
				"Title": "Measurement tool",
				"Labels": {
					"MeasureMode": "Measure mode",
					"Off": "Off",
					"Distance": "Distance",
					"Height": "Height",
					"Orthogonal": "Orthogonal",
					"Area": "Area",
					"TotalDistance": "Total Distance",
					"TotalArea": "Total Area"
				}
			},
			"CameraControl": {
				"Title": "Camera",
				"Labels": {
					"DefaultCamera": "Default Camera",
					"FirstPersonCamera": "First Person Camera"
				}
			},
			"EffectsPanel": {
				"ambientOcclusion": "Ambient Occlusion",
				"aoPower": "Power",
				"aoRadius": "Radius",
				"antiAliasing": "Anti Aliasing",
				"atmosphere": "Atmosphere",
				"depthOfField": "Depth Of Field",
				"dofFocalDepth": "Focal Depth",
				"dofFocusRange": "Focus Range",
				"dofNoFocusRange": "No Focus Range",
				"dofScale": "Scale",
				"eyeDomeLighting": "Eyedome Lighting",
				"edlColor": "Color",
				"edlStrength": "Strength",
				"edlWindow": "Window",
				"headLight": "Head Light",
				"hlAmbientColor": "Ambient Color",
				"hlDiffuseColor": "Diffuse Color",
				"sunLight": "Sun Light",
				"slAmbientColor": "Ambient Color",
				"slDiffuseColor": "Diffuse Color",
				"slShadows": "Shadows",
				"slUseLiveTime": "Use current time",
				"slTime": "Time",
				"slDate": "Date",
				"slTimezone": "Timezone",
				"starfield": "Starfield"
			}
		},
		"AppEngine": {
			"AnalyzerView": "Analyzer view",
			"ApplicationType": "Application type",
			"Bounds": "Bounds",
			"CodeSnippets": "Code snippets",
			"Crs": "CRS",
			"Legend": "Legend",
			"Loading": "loading",
			"Markup": "Markup",
			"NoScriptWarning": "Preview only, scripts won't be executed",
			"Script": "Script",
			"SelectConfig": "Select config",
			"Style": "Style",
			"StyleSet": "Styleset",
			"Vector": "Vector",
			"Snippets": {
				"Communication": {
					"Title": "Communication",
					"WaitAllPanelLoad": "Wait for all panels to load",
					"SendMessageToAllPanels": "Send message to all panels",
					"ListenToOtherPanels": "Listen to messages from other panels",
					"ListToSpecificPanel": "Listen to messages from a specific panel",
					"SendFunctionToOtherPanels": "Send a function to another panels"
				},
				"Utility": {
					"Title": "Utility",
					"LoadThirdPartyLibs": "Load external libraries"
				},
				"PointCloud": {
					"Title": "Point Cloud",
					"PointCloudStyle": "Point Cloud Styling"
				},
				"Layer": {
					"Title": "Layer",
					"FindLayerByLabel": "Find layer by label",
					"FilterLayerByType": "Filter layer by type",
					"ShowHideLayer": "Show/hide layer",
					"CreateWmsLayer": "Create WMS layer"
				},
				"MaeInterface": {
					"Title": "MAE Interface",
					"OpenWorkflow": "Open a workflow",
					"PerformQuery": "Perform a query",
					"PerformTypedQuery": "Perform a query with a typed result",
					"PerformCSVQuery": "Perform a query, CSV result",
					"PerformGeoJSONQuery": "Perform a geoJson query",
					"LoadExternalScript": "Load an external library"
				},
				"Map": {
					"Title": "Map",
					"MapInformation": "Read map information",
					"PanToPoint": "Pan to point",
					"PanToBounds": "Pan to bounds",
					"Zoom": "Zoom in/out",
					"Draw3DFeature": "Draw 3D feature",
					"AddCopyright": "Add a copyright notice"
				},
				"Recipes": {
					"Title": "Recipes",
					"ListenProcessStart": "Listen for process start",
					"ListenProcessStatusUpdate": "Listen for process status update",
					"ListenProcessFinish": "Listen for process finish",
					"GetProcessOutputs": "Get process outputs",
					"RegisterPreprocessor": "Register preprocessor",
					"SendOutputToMapView": "Send geoprocessing raster output to a Map View panel"
				},
				"Transformation": {
					"Title": "Transformations",
					"RegisterCRS": "Register a custom coordinate system",
					"PointTransformation": "Point transformation",
					"BoundsTransformation": "Bounds transformation",
					"ShapeTransformation": "Shape transformation"
				},
				"Vector": {
					"Title": "Vector",
					"EventHandlerSelectionChanged": "Add event handler for SelectionChanged event",
					"CreateCustomPainter": "Create a custom painter"
				}
			}
		}
	}
};